import React from 'react';
import ProjectList from '../ProjectList';
const Projects = () => {
  
  
    return (
      <section className='container'>
          <div>
            <h1>Projects</h1>
            <ProjectList/>
          
        </div>
      </section>
      
    );
  };
  
  export default Projects;
  